export default __webpack_public_path__ + "static/media/6.d2d3ef87.jpg";